import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7cnu2s5cyz: FaireBrandEntity = {
  token: "b_7cnu2s5cyz",
  type: "brand",
  name: "You Play I Pray",
  avatarUrl:
    "https://cdn.faire.com/fastly/f4524daf4420431b0f5d794642c2996105d2aa595a8751011b6170de91fa8f4a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aee548dd6d7cd9f9e96b81113fd6d6368497388c62086f9136d05f5fab2e2594.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f4524daf4420431b0f5d794642c2996105d2aa595a8751011b6170de91fa8f4a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aee548dd6d7cd9f9e96b81113fd6d6368497388c62086f9136d05f5fab2e2594.png",
  location: "Orange , TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 98,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi I’m Kylie and I am so glad you are here! I am the founder and creator of You Play I Pray, which is the product of a life changing journey through my husband's professional baseball career that led us to a relationship with Christ. We found freedom to enjoy the process once we understood the only two areas we had control over were playing and praying. Our hope and mission is to continue reaching hearts for Christ in the same way He reached ours. \n\nYou can read more of the journey at youplayipray.com ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:47.981Z",
    importedBy: "entity-db-cli",
  },
};
